import {
  ADD_FLEET,
  ADD_FLEET_SUCCESS,
  GET_FLEET_BY_FLEET_ID,
  GET_FLEET_BY_FLEET_ID_SUCCESS,
  CLEAN_FASTAG_TRANSACTION_HISTORY,
  GENERATE_MASTER_ACCOUNT_STATEMENT_SUCCESS,
  GENERATE_MASTER_ACCOUNT_STATEMENT,
  GENERATE_FASTAG_VEHICLE_STATEMENT,
  GENERATE_FASTAG_VEHICLE_STATEMENT_SUCCESS,
  CLEAN_FLEET_LOADER,
  UPDATE_FLEET,
  UPDATE_FLEET_SUCCESS,
  ADVANCED_VEHICLE_LIST,
  ADVANCED_VEHICLE_LIST_SUCCESS,
  SAVE_VEHICLE_PROFILE_DATA,
  SAVE_VEHICLE_PROFILE_DATA_SUCCESS,
  EDIT_VEHICLE_PROFILE_DATA,
  EDIT_VEHICLE_PROFILE_DATA_SUCCESS,
  GET_VEHICLE_PROFILE_DATA,
  CLEAR_VEHICLE_PROFILE_DATA,
  GET_VEHICLE_PROFILE_DATA_SUCCESS,
  GET_KARZA_VEHICLE_DATA,
  CLEAR_KARZA_VEHICLE_DATA,
  GET_KARZA_VEHICLE_DATA_SUCCESS,
  GET_SERVICE_HISTORY,
  CLEAR_SERVICE_HISTORY,
  GET_SERVICE_HISTORY_SUCCESS,
  DELETE_SERVICE_HISTORY,
  DELETE_SERVICE_HISTORY_SUCCESS,
  GET_SERVICE_ITEMS,
  ADD_SERVICE_ITEMS,
  GET_SERVICE_ITEMS_SUCCESS,
  ADD_SERVICE_ITEMS_SUCCESS,
  SAVE_KARZA_VEHICLE,
  SAVE_KARZA_VEHICLE_SUCCESS,
  UPDATE_KARZA_VEHICLE,
  UPDATE_KARZA_VEHICLE_SUCCESS,
  GET_FLEET_ANALYTICS,
  GET_FLEET_ANALYTICS_SUCCESS,
  GET_GPS_STATUS,
  GET_GPS_STATUS_SUCCESS,
  GPS_CONNECT,
  GPS_CONNECT_SUCCESS,
  GET_GPS_DATA,
  GET_GPS_DATA_SUCCESS,
  LAST_LOCATION,
  LAST_LOCATION_SUCCESS,
  GPS_COMPUTED_VEHICLE_DATA,
  GPS_COMPUTED_VEHICLE_DATA_SUCCESS, 
  CLEAN_GPS_COMPUTED_VEHICLE_DATA,   
  DOWNLOAD_VEHICLE_LEDGER,
  DOWNLOAD_VEHICLE_LEDGER_SUCCESS,
  CLEAN_LAST_LOCATION_DATA
} from "../storeTypes";

const INIT_STATE = {
  loader: false,
  fleetAdded:{},
  fleet: [],
  fleetFastagWallet: {},
  masterAccount: [],
  fastagVehicleStatement: {},
  advancedVehicleList:[],
  advancedVehicleListCount:null,
  fleetListLoader: false,
  vehicleProfileData: {serviceData: [], documentData: []},
  karzaVehicleData: {},
  serviceHistory: [],
  serviceHistoryCount: 0,
  serviceItems: {},
  serviceHistoryTotal: [],
  gpsComputedVehicleData:[],
  gpsComputedVehicleDataLoader:false
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ADD_FLEET: {
      return {
        ...state,
        loader: true,
      };
    }
    case ADD_FLEET_SUCCESS: {
      return {
        ...state,
        loader: false,
        // fleetAdded:action.payload,
      };
    }
    case SAVE_KARZA_VEHICLE: {
      return {
        ...state,
        loader: true,
      };
    }
    case SAVE_KARZA_VEHICLE_SUCCESS: {
      return {
        ...state,
        loader: false,
      };
    }

    case UPDATE_KARZA_VEHICLE: {
      return {
        ...state,
        loader: true,
      };
    }
    case UPDATE_KARZA_VEHICLE_SUCCESS: {
      return {
        ...state,
        loader: false,
      };
    }

    case GET_GPS_STATUS: {
      return {
        ...state,
        loader: true,
      
      };
    }
    case GET_GPS_STATUS_SUCCESS: {
      console.log("GET_GPS_STATUS_SUCCESSGET_GPS_STATUS_SUCCESS",action)
      return {
        ...state,
        loader: false,
        gpsStatus: action.payload,
      };
    }

    case GPS_CONNECT: {
      return {
        ...state,
        loader: true,
      };
    }
    case GPS_CONNECT_SUCCESS: {
      return {
        ...state,
        loader: false,
      };
    }

    case GET_GPS_DATA: {
      return {
        ...state,
        loader: true,
      };
    }
    case GET_GPS_DATA_SUCCESS: {
      return {
        ...state,
        loader: false,
        gpsData: action.payload
      };
    }

    case LAST_LOCATION: {
      return {
        ...state,
        loader: true,
      };
    }
    case LAST_LOCATION_SUCCESS: {
      return {
        ...state,
        loader: false,
        gpsData: action.payload
      };
    }
    case CLEAN_LAST_LOCATION_DATA: {
      return {
        ...state,
        gpsData: []
        // gpsComputedVehicleData: action.payload
      };
    }

    case GPS_COMPUTED_VEHICLE_DATA: {
      return {
        ...state,
        gpsComputedVehicleDataLoader: true,
      };
    }
    case GPS_COMPUTED_VEHICLE_DATA_SUCCESS: {
      return {
        ...state,
        gpsComputedVehicleDataLoader: false,
        gpsComputedVehicleData: [
          ...state.gpsComputedVehicleData,...action?.payload?.data,
        ],
        // gpsComputedVehicleData: action.payload
      };
    }
    case CLEAN_GPS_COMPUTED_VEHICLE_DATA: {
      return {
        ...state,
        gpsComputedVehicleData: []
        // gpsComputedVehicleData: action.payload
      };
    }

    case GET_FLEET_BY_FLEET_ID: {
      return {
        ...state,
        loader: true,
      };
    }
    case GET_FLEET_BY_FLEET_ID_SUCCESS: {
      return {
        ...state,
        loader: false,
        fleet: action.payload,
      };
    }
    case CLEAN_FASTAG_TRANSACTION_HISTORY: {
      console.log("red-> fleet-- clean ");
      return {
        ...state,
        loader: false,
      };
    }
    case GENERATE_MASTER_ACCOUNT_STATEMENT: {
      console.log("red", action.payload);
      return {
        ...state,
        loader: true,
      };
    }
    case GENERATE_MASTER_ACCOUNT_STATEMENT_SUCCESS: {
      //console.log("red-> fleet-- ");
      return {
        ...state,
        loader: false,
        masterAccountStatement: action.payload,
      };
    }
    case GENERATE_FASTAG_VEHICLE_STATEMENT: {
      // console.log("red",action.payload);
      return {
        ...state,
        loader: true,
      };
    }
    case GENERATE_FASTAG_VEHICLE_STATEMENT_SUCCESS: {
      //console.log("red-> fleet-- ");
      return {
        ...state,
        loader: false,
        fastagVehicleStatement: action.payload,
      };
    }
    case CLEAN_FLEET_LOADER:{
      console.log("mesaage------------- reducer loader");
      return {
          ...state,
          loader:false,
      }
    }
    case UPDATE_FLEET: {
      return {
        ...state,
        loader: true,
      };
    }
    case UPDATE_FLEET_SUCCESS: {
      return {
        ...state,
        loader: false,
      };
    }
    case ADVANCED_VEHICLE_LIST:{
      return {
        ...state,
        loader:true,
        fleetListLoader:true,

      }
    }
    case ADVANCED_VEHICLE_LIST_SUCCESS:{
      return {
        ...state,
        loader:false,
        advancedVehicleList:action?.payload?.result,
        advancedVehicleListCount:action?.payload?.count,
        fleetListLoader:false,
      }
    }

    case SAVE_VEHICLE_PROFILE_DATA: {
      return {
        ...state,
        loader: true,
      };
    }
    case SAVE_VEHICLE_PROFILE_DATA_SUCCESS: {
      return {
        ...state,
        loader: false,
      };
    }

    case EDIT_VEHICLE_PROFILE_DATA: {
      return {
        ...state,
        loader: true,
      };
    }
    case EDIT_VEHICLE_PROFILE_DATA_SUCCESS: {
      return {
        ...state,
        loader: false,
      };
    }

    case GET_VEHICLE_PROFILE_DATA: {
      return {
        ...state,
        loader: true,
      };
    }
    case CLEAR_VEHICLE_PROFILE_DATA: {
      console.log("CLEAR_VEHICLE_PROFILE_DATA");
      return {
        ...state,
        vehicleProfileData: {serviceData: [], documentData: []},
      };
    }
    case GET_VEHICLE_PROFILE_DATA_SUCCESS: {
      console.log("GET_VEHICLE_PROFILE_DATA_SUCCESS",action?.payload);

      return {
        ...state,
        loader: false,
        vehicleProfileData: action?.payload,
      };
    }


    case GET_KARZA_VEHICLE_DATA: {
      return {
        ...state,
        loader: true,
      };
    }
    case CLEAR_KARZA_VEHICLE_DATA: {
      console.log("CLEAR_KARZA_VEHICLE_DATA");
      return {
        ...state,
        karzaVehicleData: {},
      };
    }
    case GET_KARZA_VEHICLE_DATA_SUCCESS: {
      console.log("GET_KARZA_VEHICLE_DATA_SUCCESS",action?.payload);

      return {
        ...state,
        loader: false,
        karzaVehicleData: action?.payload,
      };
    }


    case GET_SERVICE_HISTORY: {
      return {
        ...state,
        loader: true,
      };
    }
    case CLEAR_SERVICE_HISTORY: {
      return {
        ...state,
        serviceHistory: [],
        serviceHistoryCount: 0
      };
    }
    case GET_SERVICE_HISTORY_SUCCESS: {
      console.log("GET_SERVICE_HISTORY_SUCCESS",action?.payload);

      return {
        ...state,
        loader: false,
        serviceHistory: action?.payload?.rows,
        serviceHistoryCount: action?.payload?.count,
        // serviceHistoryTotal: state.serviceHistoryTotal.push(action?.payload?.rows),

      };
    }

    case DELETE_SERVICE_HISTORY: {
      return {
        ...state,
        loader: true,
      };
    }
    case DELETE_SERVICE_HISTORY_SUCCESS: {
      return {
        ...state,
        loader: false,
      };
    }
    
    case GET_SERVICE_ITEMS: {
      return {
        ...state,
        loader: true,
      };
    }
    case GET_SERVICE_ITEMS_SUCCESS: {
      return {
        ...state,
        serviceItems: action?.payload,
      };
    }

    case ADD_SERVICE_ITEMS: {
      return {
        ...state,
        loader: true,
      };
    }
    case ADD_SERVICE_ITEMS_SUCCESS: {
      return {
        ...state,
        loader: false,
      };
    }
    
    case GET_FLEET_ANALYTICS: {
      return {
        ...state,
        loader: true,
      };
    }
    case GET_FLEET_ANALYTICS_SUCCESS: {
      return {
        ...state,
        loader: false,
        analyticalData: action?.payload
      };
    }
    case DOWNLOAD_VEHICLE_LEDGER: {
      return {
        ...state,
        loader: true,
      };
    }
    case DOWNLOAD_VEHICLE_LEDGER_SUCCESS : {
      return {
        ...state,
        loader: false,
      };
    }
    default: {
      return state;
    }
  }
};
